import React from 'react'
import Users from "../../org/users"

export default function GroupUsers() {
  return <Users isGroupAdminMode />
}
